(function () {
  'use strict';

  angular.module('app').component('bookingsPage', BookingsPageComponent());

  function BookingsPageComponent() {
    return {
      bindings: {},
      controller: BookingListCtrl,
      controllerAs: 'vm',
      templateUrl: './app/ajs/bookings/bookings-page.component.html',
    };
  }

  BookingListCtrl.$inject = [
    '$location',
    'AbilityService',
    'SessionService',
    'BookingService',

    // Angular downgraded service
    'ng2Router',
  ];

  function BookingListCtrl(
    $location,
    AbilityService,
    SessionService,
    BookingService,

    // Angular downgraded service
    ng2Router
  ) {
    var vm = this;

    var accountCompanyWebsites = SessionService.getSelectedAccountCompany().websites;

    if (accountCompanyWebsites.length === 0) {
      vm.errorWebsites = true;
      vm.companyId = SessionService.getSelectedAccountCompany().id;
    }

    vm.permissions = {
      canCreate: AbilityService.can('create_booking_accountadmin'),
    };

    vm.websiteId = SessionService.getSelectedAccountCompanyWebsite().id;

    // Methods
    vm.createBooking = createBooking;
    vm.onShowBooking = onShowBooking;

    // Initializers
    getBookings();

    function getBookings() {
      vm.loadingItems = true;
      BookingService.getBookings().then(function (data) {
        vm.items = data.items;
        vm.meta = data.meta;
        vm.meta.statsBookings = data.stats;

        vm.totalItems = vm.meta.totalItems;

        setBookingItems();

        vm.loadingItems = false;
      });
    }

    function setBookingItems() {
      vm.items.forEach((booking) => {
        var totalBookingItemsConfirmed = 0;
        booking.booking_items.forEach((bookingItem) => {
          if (bookingItem.status === 'confirmed') {
            totalBookingItemsConfirmed += 1;
          }
        });

        booking.allBookingItemsConfirmed =
          booking.booking_items.length === totalBookingItemsConfirmed ? true : false;

        booking.atLeastOneItemIsMissingPickupTime = booking.booking_items.some(
          (bookingItem) => bookingItem.booking_type !== 'hotel' && !bookingItem.pickup_time
        );
      });
    }

    function createBooking() {
      $location.path('/bookings/new');
    }

    function onShowBooking(booking, mode) {
      $location.path(`/bookings/${booking.id}`).search({ mode: mode });
    }

    vm.goToWebsiteNew = () => {
      ng2Router.navigate(['/ng/websites/new']);
    };
  }
})();
